<template>
    <div class="steps">
        <div v-for="steps_item in steps_items" :key="steps_item.id">
            <main_steps v-if="steps_item.children"
                :steps_item="steps_item"
                :active_step="active_step" v-on:set_active_step="set_active_step"
            />
            <div v-else :class="'main_step' + (active_step == steps_item.id ? ' active' : '')" @click="() => set_active_step(steps_item)">
                {{ steps_item.title }}
                <span v-if="steps_item.subtitle" class="d-block" style="font-size: .75rem;">{{ steps_item.subtitle }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import main_steps from "./main"

export default
{
    props :
    {
        steps_items : Array,
    },

    components :
    {
        main_steps,
    },

	data()
	{
		return {
            active_step : null,
		}
	},

    methods :
    {
        set_active_step(step)
        {
            var active_step_id

            if (step.not_selectable && step.children) active_step_id = step.children[0].id
            else active_step_id = step.id

            this.active_step = active_step_id
            this.$emit("set_active_step", active_step_id)
        }
    }
}
</script>

<style scoped>
.steps
{
    overflow: auto;
    box-sizing: content-box;
    flex: 1;
    width: 260px;
    max-width: 260px;
    border-left: 1px solid var(--bft-blue-200);
    height: 100%;
}

.main_step
{
    padding: .5rem .5rem .5rem 3rem;
    border-radius: 0 .5rem .5rem 0;
    cursor: pointer;
}
</style>

<style>
.steps .active
{
    background-color: var(--bft-blue-50);
}
</style>
